import request from "./../../core/api";

export const getListMenu = (shopId) => {
  return request({
    url: `/shop/${shopId}/menu/`,
    method: "get",
  });
};

export const getListStaff = (shopId) => {
  return request({
    url: `/shop/${shopId}/staff/`,
    method: "get",
  });
};

export const getListTable = (params) => {
  const { shopId, query } = params;
  return request({
    url: `/shop/${shopId}/table/`,
    method: "get",
    params: query,
  });
};

export const getListCustomer = (params) => {
  const { shopId, query } = params;
  return request({
    url: `/shop/${shopId}/customer/`,
    method: "get",
    params: query,
  });
};

export const getListParticipants = (shopId) => {
  return request({
    url: `/shop/${shopId}/guest-capacity/`,
    method: "get",
  });
};

export const getListSeat = (params) => {
  const { shopId, query } = params;
  return request({
    url: `/shop/${shopId}/seat/`,
    method: "get",
    params: query,
  });
};
